<template>
  <body class="body">
    <Loading :active.sync="loading" :lock-scroll="true" :is-full-page="true" :opacity="0.95" color="#F58549">
      <div slot="default" class="loading">Se încarcă...</div>
    </Loading>
    <div v-if="test">

      <!-- INAINTE DE TEST -->
      <div v-if="!started && !finished && canTake">
        <div class="container" id="formContent1">
          <div style="font-size: 20px; font-weight: bold;">
            {{test.name}}
          </div>
          <div>
            Timp disponibil: {{test.minutes}} minute
          </div>
          <div>
            <p>Testul conține 18 probleme, cu câte 5 variante de răspuns.</p>
            <p>Fiecare răspuns corect valorează 0.5 puncte.</p>
            <p>Se acordă 1 punct din oficiu.</p>
          </div>
          <div style="font-weight: bold;">
            Atenție! Testul se poate da o singură dată.
          </div>
          <div>
            Succes!
          </div>

          <div style="margin-top: 4%;">
            <button type="button" class="buton btn" @click="$refs.alertBeginAttempt.open()">Start test</button>
            <button
              type="button"
              class="buton btn"
              style="margin-left: 2%;"
              @click="$router.go(-1)">
              Înapoi
            </button>
          </div>

        </div>
      </div>

      <!-- A DAT DEJA TESTUL -->
      <div v-if="!started && !finished && !canTake" class="container" id="formContent1">
        <div style="font-size: 20px; font-weight: bold;">
          {{test.name}}
        </div>

        <div v-if="result > 0">
          <div>Ai dat deja acest test!</div>
          <div>Nota: {{result}} din 10</div>
        </div>
        <div v-else>
          <div><strong>Test în desfășurare</strong></div>
          <div>Dacă ai părăsit pagina de test fără a apăsa butonul "Am terminat", va trebui să mai aștepți înainte să îți poți vedea rezultatul.</div>
        </div>

        <div>
          <button
            type="button"
            class="buton btn"
            style="width: 30vh;"
            @click="$router.go(-1)">
            Înapoi
          </button>
        </div>
      </div>

      <!-- TEST IN DESFASURARE -->
      <div v-if="started && !finished" class="container" id="formContent3">
        <div class="sticky">
          <div style="font-size:18px; font-weight: bold;">
            {{test.name}}
          </div>

          <div>
            <vue-countdown ref="timer" :time="test.minutes * 60 * 1000 - 1" :auto-start="false" @end="endTest(true)">
              <template slot-scope="props">
                <span style="font-size: 18px;">Timp rămas: {{ props.minutes }}:{{ props.seconds }}</span>
              </template>
            </vue-countdown>
          </div>

          <div>
            <button
              type="button"
              class="buton btn"
              @click="$refs.alertSubmit.open()"
              >
                Am terminat
            </button>
          </div>
        </div>

        <div style=" margin-top: 25px; font-family: Computer Modern; margin-top: 16vh">
          <!-- <vue-custom-scrollbar class="scroll-area"> -->
            <div
              v-for="question in questions"
              :key="question.id"
              class="containerproblema">

              <div>
                <strong>Ex {{question.nr + 1}}:</strong>
              </div>

              <div>
                {{question.text}}
              </div>

              <img v-if="question.id===616" class="image2" :src="getImg(question.id)"/>
              <img v-if="getImg(question.id) && question.id !== 616" class="image" :src="getImg(question.id)"/>

              <div class="container checkboxes">
                <div style="margin-left: 5vh;text-align: left;">
                  <input type="radio" :id="question.id + 'A'" v-model="answers[question.nr]" :value="question.answers[0]">
                  <label :for="question.id + 'A'">
                    {{question.answers[0]}}
                  </label>
                </div>

                <div style="margin-left: 5vh;text-align: left;">
                  <input type="radio" :id="question.id + 'B'" v-model="answers[question.nr]" :value="question.answers[1]">
                  <label :for="question.id + 'B'">
                    {{question.answers[1]}}
                  </label>
                </div>

                <div style="margin-left: 5vh;text-align: left;">
                  <input type="radio" :id="question.id + 'C'" v-model="answers[question.nr]" :value="question.answers[2]">
                  <label :for="question.id + 'C'">
                    {{question.answers[2]}}
                  </label>
                </div>

                <div style="margin-left: 5vh;text-align: left;">
                  <input type="radio" :id="question.id + 'D'" v-model="answers[question.nr]" :value="question.answers[3]">
                  <label :for="question.id + 'D'">
                    {{question.answers[3]}}
                  </label>
                </div>

                <div style="margin-left: 5vh;text-align: left;">
                  <input type="radio" :id="question.id + 'E'" v-model="answers[question.nr]" value="Altul">
                  <label :for="question.id + 'E'">Alt răspuns</label>
                </div>
              </div>

            </div>
          <!-- </vue-custom-scrollbar> -->
        </div>
      </div>

      <!-- TERMINARE TEST -> AFISARE REZULTATE -->
      <div v-if="finished" class="container">
        <div class="containerproblema">
          <div style="text-align: center;" v-if="result > 0 && result <= 4.5">
            <img style="width: 20vh" src="../img/nu_renunta.png"/>
            <img class="updown" style="width: 15vh;margin-top: 2vh;" src="../img/bees/insuficient.png"/>
          </div>
          <div style="text-align: center;" v-if="result >= 5 && result <= 6">
            <img style="width: 20vh" src="../img/poti_mai_mult.png"/>
            <img class="updown" style="width: 15vh;margin-top: 2vh;" src="../img/bees/suficient.png"/>
          </div>
          <div style="text-align: center;" v-if="result >= 6.5 && result <= 8">
            <img style="width: 20vh" src="../img/putina_atentie.png"/>
            <img class="updown" style="width: 15vh;margin-top: 2vh;" src="../img/bees/bine.png"/>
          </div>
          <div style="text-align: center;" v-if="result >= 8.5 && result <= 9.5">
            <img style="width: 20vh" src="../img/aproape_perfect.png"/>
            <img class="updown" style="width: 15vh;margin-top: 2vh;" src="../img/bees/foartebine.png"/>
          </div>
          <div style="text-align: center;" v-if="result === 10">
            <img style="width: 20vh" src="../img/felicitari.png"/>
            <img class="updown" style="width: 15vh;margin-top: 2vh;" src="../img/bees/excelent.png"/>
          </div>

          <div style="text-align: center;">
            <h5> Răspunsuri corecte: {{(result - 1) * 2}} din 18 </h5>
            <h5> Nota: {{result}} </h5>
          </div>
        </div>

        <div class="containerproblema" style="text-align: center;padding: 0%;" v-if="wrongAnswers.length > 0">
          <img src="../img/intrebari.png" style="width: 50vh"/>
        </div>

        <div v-for="answer in wrongAnswers" :key="answer.id" class="containerproblema">
          <div>
            <strong> Enunț: &nbsp;</strong> {{answer.text}}
          </div>
          <div class="container">
            <img v-if="getImg(answer.id)" style="width: 35vh" :src="getImg(answer.id)"/>
          </div>
          <div>
            <strong>Răspunsul tău: &nbsp; </strong> {{answer.user_answ}}
          </div>
          <div>
            <strong>Corect: &nbsp; </strong> {{answer.correct_answ}}
            </div>
        </div>
      </div>
    </div>

    <sweet-modal ref="alertBeginAttempt" icon="warning">
      <div><strong>Testul poate fi dat o singură dată.</strong></div>
      <div><strong>Dacă părăsești pagina în timpul testului vei rămâne cu răspunsurile curente.</strong></div>
      <br><div><strong>Începi testul?</strong></div><br>
      <div>
        <button type="button" class="buton btn" style="margin-right: 2vh;" @click="startTest()">Începe testul</button>
        <button type="button" class="buton btn" @click="$refs.alertBeginAttempt.close()">Anulează</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="alertUnanswered" icon="error">
      Nu ai răspuns la toate întrebările.
    </sweet-modal>

    <sweet-modal ref="alertSubmit" icon="warning">
      <div style="margin-bottom: 2vh;">Ești sigur că vrei să termini testul?</div>

      <div>
        <button type="button" class="buton btn" style="margin-right: 2vh;" @click="endTest(false)">Finalizează</button>
        <button type="button" class="buton btn" @click="$refs.alertSubmit.close()">Anulează</button>
      </div>
    </sweet-modal>
  </body>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import { mapActions } from 'vuex'
// import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'Test',

  components: {
    VueCountdown,
    SweetModal,
    Loading
    // vueCustomScrollbar
  },

  data: () => ({
    test: null,
    questions: null,
    started: false,
    finished: false,
    canTake: false,
    answers: [],
    finalAnswers: [],
    result: 0.0,
    wrongAnswers: [],
    sending: false,
    rendering: false
  }),

  computed: {
    loading: function () {
      return this.sending || this.rendering
    }
  },

  watch: {
    answers: function () {
      this.updateTest()
    }
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },

  beforeRouteLeave(to, from, next) {
    if (this.started && !this.finished) {
      if (!window.confirm("Vei pierde tot progresul")) {
        return;
      }
    }

    next();
  },

  mounted () {
    axios.get(`/tests/${this.$route.params.test}`).then(response => {
      this.test = response.data.test
      this.questions = response.data.questions
      this.canTake = response.data.canTake
      this.result = response.data.result
    }).catch((e) => {
      if(e.response.status == 401){
        this.sessionExpired()
        alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
        this.$router.replace({ name: 'login' })
      }
    })
  },

  methods: {
    ...mapActions({
      refreshToken: 'auth/refreshToken',
      beginTesting: 'globals/beginTesting',
      endTesting: 'globals/endTesting',
      sessionExpired: 'auth/sessionExpired'
    }),

    reRender() {
      if(window.MathJax) {
        this.rendering = true
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
          this.rendering = false
          if(this.started && !this.finished) {
            this.$refs.timer.start()
          }
        });
      }
    },

    preventNav(event) {
      if (!this.started || this.finished) return
      event.preventDefault()
      event.returnValue = ""
    },

    getImg(id) {
      try {
        var img = require(`../img/questions/${id}.png`)
      }
      catch(err) {
        img = null
      }

      return img
    },

    startTest() {
      this.sending = true
      this.refreshToken().then(() => {
        this.$refs.alertBeginAttempt.close()
        this.started = true
        this.beginTesting()

        this.$nextTick(() => {
          this.reRender();
        })

        axios.post('/begin-attempt', {
          test_id: this.$route.params.test
        }).then(() => {
          this.sending = false
        }).catch(error => {
          alert(error)
          location.reload()
        })
      })
    },

    updateTest() {
      var tempAnswers = []
      for(var i = 0; i < this.questions.length; i++){
        if(!this.answers[this.questions[i].nr]) {
          tempAnswers.push({
            id: this.questions[i].id,
            answer: "Nu ai răspuns"
          })
        } else {
          tempAnswers.push({
            id: this.questions[i].id,
            answer: this.answers[this.questions[i].nr]
          })
        }
      }

      axios.post('/update-attempt', {
        test_id: this.$route.params.test,
        answers: tempAnswers
      }).catch(error => {
        console.log(error)
      })
    },

    endTest(timeout) {
      this.$refs.alertSubmit.close()

      if(timeout) {
        for(var i = 0; i < this.questions.length; i++){
          if(!this.answers[this.questions[i].nr]) {
            this.finalAnswers.push({
              id: this.questions[i].id,
              answer: "Nu ai răspuns"
            })
          } else {
            this.finalAnswers.push({
              id: this.questions[i].id,
              answer: this.answers[this.questions[i].nr]
            })
          }
        }
      } else {
        for(i = 0; i < this.questions.length; i++){
          if(!this.answers[this.questions[i].nr]) {
            this.$refs.alertSubmit.close()
            this.$refs.alertUnanswered.open()
            this.finalAnswers = []
            return
          }

          this.finalAnswers.push({
            id: this.questions[i].id,
            answer: this.answers[this.questions[i].nr]
          })
        }
      }

      this.endTesting()
      clearInterval(this.updateInterval)

      this.sending = true
      axios.post('/finish-attempt', {
        test_id: this.$route.params.test,
        answers: this.finalAnswers
      }).then(response => {
        this.showWrongAnswers(response)
        this.sending = false
      }).catch(() => {
        axios.post('/finish-attempt', {
          test_id: this.$route.params.test,
          answers: this.finalAnswers
        }).then(response => {
          this.showWrongAnswers(response)
          this.sending = false
        }).catch(error => {
          console.log(error)
          location.reload()
        })
      })
    },

    showWrongAnswers(response) {
      this.result = response.data.result
      this.wrongAnswers = response.data.wrong_answers

      this.$refs.alertSubmit.close()
      this.$refs.alertUnanswered.close()

      this.finished = true
      this.$nextTick(() => {
        this.reRender()
      })
    }
  }
}
</script>

<style scoped>
.loading {
  font-size: 6vw;
  color: #F58549;
}

@media (min-width: 600px) {
  .loading {
    font-size: 3vw;
    color: #F58549;
  }
}

.image {
  max-width: 40vw;
  max-height: 50vh;
  width: auto;
  height: auto;
}

.image2 {
  width: 70vw;
  height: 45vh;
}

@media (min-width: 600px) {
  .image {
    max-width: 20vw;
    max-height: 30vh;
    width: auto;
    height: auto;
  }

  .image2 {
    max-width: 70vw;
    max-height: 70vh;
    width: auto;
    height: auto;
  }
}

.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  width: fit-content;
  height: fit-content;
}

.updown {
    animation-name: floating;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}

@keyframes floating {
    from { transform: translate(0,  0px); }
    50%  { transform: translate(-0, -10px) rotate(5deg);}
    to   { transform: translate(0, -0px); }
}

#formContent1 {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: fit-content;
  max-width: 80%;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formContent2 {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: fit-content;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formContent3 {

  width: 80%;
  height: fit-content;
  position: relative;
  text-align: center;
}

.containerproblema {
  margin-bottom: 25px;
  background-color: white;
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  padding: 3%;
}

.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}

.containerstanga {
  display: flex;
  justify-content: left;
  align-content: left;
  margin-left: 2%;
}

.scroll-area {
  position: relative;
  margin: auto;
  overflow-y: hidden;
}

input[type="radio"]{
  margin: 0 10px 0 10px;
}

.sticky {
  z-index:1;
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  background-color: #FBEFDA;
  padding: 5px;
  border-bottom: 2px solid #F7CCA1;
  -webkit-box-shadow: 0 5px 5px 0 rgba(0,0,0,0.3);
  box-shadow: 0 5px 5px 0 rgba(0,0,0,0.3);
}
</style>
